/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineObject2,
    InlineObject2FromJSON,
    InlineObject2ToJSON,
    TrustDto,
    TrustDtoFromJSON,
    TrustDtoToJSON,
    TrustHolderDto,
    TrustHolderDtoFromJSON,
    TrustHolderDtoToJSON,
} from '../models';

export interface AddCARequest {
    inlineObject2?: InlineObject2;
}

export interface AddTrustHolderRequest {
    trustHolderDto: TrustHolderDto;
}

export interface DeleteCARequest {
    thumbPrint: string;
}

export interface DeleteTrustHolderRequest {
    trustHolderEntityId: string;
}

export interface DownloadCARequest {
    thumbPrint: string;
}

/**
 * 
 */
export class TrustControllerApi extends runtime.BaseAPI {

    /**
     */
    async addCARaw(requestParameters: AddCARequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<TrustDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/pkix/add-ca`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject2ToJSON(requestParameters.inlineObject2),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrustDtoFromJSON(jsonValue));
    }

    /**
     */
    async addCA(inlineObject2?: InlineObject2, initOverrides?: RequestInit): Promise<TrustDto> {
        const response = await this.addCARaw({ inlineObject2: inlineObject2 }, initOverrides);
        return await response.value();
    }

    /**
     */
    async addTrustHolderRaw(requestParameters: AddTrustHolderRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.trustHolderDto === null || requestParameters.trustHolderDto === undefined) {
            throw new runtime.RequiredError('trustHolderDto','Required parameter requestParameters.trustHolderDto was null or undefined when calling addTrustHolder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/pkix/add-trustholder`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TrustHolderDtoToJSON(requestParameters.trustHolderDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async addTrustHolder(trustHolderDto: TrustHolderDto, initOverrides?: RequestInit): Promise<void> {
        await this.addTrustHolderRaw({ trustHolderDto: trustHolderDto }, initOverrides);
    }

    /**
     */
    async deleteCARaw(requestParameters: DeleteCARequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.thumbPrint === null || requestParameters.thumbPrint === undefined) {
            throw new runtime.RequiredError('thumbPrint','Required parameter requestParameters.thumbPrint was null or undefined when calling deleteCA.');
        }

        const queryParameters: any = {};

        if (requestParameters.thumbPrint !== undefined) {
            queryParameters['thumbPrint'] = requestParameters.thumbPrint;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/pkix/delete-ca`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteCA(thumbPrint: string, initOverrides?: RequestInit): Promise<void> {
        await this.deleteCARaw({ thumbPrint: thumbPrint }, initOverrides);
    }

    /**
     */
    async deleteTrustHolderRaw(requestParameters: DeleteTrustHolderRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.trustHolderEntityId === null || requestParameters.trustHolderEntityId === undefined) {
            throw new runtime.RequiredError('trustHolderEntityId','Required parameter requestParameters.trustHolderEntityId was null or undefined when calling deleteTrustHolder.');
        }

        const queryParameters: any = {};

        if (requestParameters.trustHolderEntityId !== undefined) {
            queryParameters['trustHolderEntityId'] = requestParameters.trustHolderEntityId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/pkix/delete-trustholder`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteTrustHolder(trustHolderEntityId: string, initOverrides?: RequestInit): Promise<void> {
        await this.deleteTrustHolderRaw({ trustHolderEntityId: trustHolderEntityId }, initOverrides);
    }

    /**
     */
    async downloadCARaw(requestParameters: DownloadCARequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.thumbPrint === null || requestParameters.thumbPrint === undefined) {
            throw new runtime.RequiredError('thumbPrint','Required parameter requestParameters.thumbPrint was null or undefined when calling downloadCA.');
        }

        const queryParameters: any = {};

        if (requestParameters.thumbPrint !== undefined) {
            queryParameters['thumbPrint'] = requestParameters.thumbPrint;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/pkix/download-ca`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async downloadCA(thumbPrint: string, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.downloadCARaw({ thumbPrint: thumbPrint }, initOverrides);
        return await response.value();
    }

    /**
     */
    async listTrustHoldersRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<TrustHolderDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/pkix/trustholders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrustHolderDtoFromJSON));
    }

    /**
     */
    async listTrustHolders(initOverrides?: RequestInit): Promise<Array<TrustHolderDto>> {
        const response = await this.listTrustHoldersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async listTrustsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<TrustDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/pkix/trusts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrustDtoFromJSON));
    }

    /**
     */
    async listTrusts(initOverrides?: RequestInit): Promise<Array<TrustDto>> {
        const response = await this.listTrustsRaw(initOverrides);
        return await response.value();
    }

}
